import React from 'react';
import values from 'lodash/values';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import {withRouter} from 'react-router-dom';
import * as ResourceApi from 'api/resources';
import DocumentTitle from 'react-document-title';
import setDisplayName from 'recompose/setDisplayName';
import {createResourcePageSelector, createResourcePageItemsSelector} from 'resources/selectors';
import {requestPrizeWinnersAction, expandRow, collapseRow} from './actions';
import SecretSonicSpinner from 'components/common/SecretSonicSpinner';
import {updatePageNumberForResourceAction} from 'resources/actions';
import MultipleWinnersHeader from './MultipleWinnersHeader';
import {createResourceSelector} from 'resources/selectors';
import {filterOptionsFactory} from 'viewOptions/factories';
import ItemExplorer from 'components/common/ItemExplorer';
import {isSponsored} from 'pages/EditPrize/utils';
import columns from './columns';
import {
  EmptyFunc,
  SortDirection,
  ItemExplorerViewOptions,
  pageCount,
  prependRecentIfFirstPage
} from 'utils/DBUtils';

const getResourcePage = createResourcePageSelector(ResourceApi.Types.PrizeEntry);
const getPageItems = createResourcePageItemsSelector(ResourceApi.Types.PrizeEntry);

const mapStateToProps = (state, props) => {
  const {prizeId} = props.match.params;
  const getPrize = createResourceSelector(prizeId);
  const prize = getPrize(state.resources) || {};

  const prizeType = isSponsored(prize) ? 'sponsored' : 'editorial';

  const {
    prizeHistoriesByUserId,
    fetchingWinners,
    masterSearchResults,
    currentExpandedRow
  } = state.multipleWinners;

  const resourcePage = getResourcePage(state.resources);
  const pageSize = resourcePage.count;
  const currentPage = resourcePage.page;
  const totalWinners = resourcePage.total;

  // extend each winning entry for this prize with a custom property for storing that
  // entrant's prize history. same goes for search results being rendered in this table.
  const addPrizeHistory = winner => ({
    ...winner,

    // elide any prize history entries that duplicate a winning entry for this prize.
    prizeHistory: (prizeHistoriesByUserId[winner.userId] || []).filter(entry => entry.id !== winner.id)
  });

  const pageItems = getPageItems(state.resources).map(addPrizeHistory);
  const searchResults = masterSearchResults.map(addPrizeHistory);

  const winners = prependRecentIfFirstPage(currentPage, pageSize, [], pageItems);

  return {
    fetchingWinners,
    winners,
    prizeId,
    prizeType,
    searchResults,
    currentExpandedRow,
    pageSize,
    currentPage,
    totalWinners
  };
};

const mapDispatchToProps = {
  expandRow,
  collapseRow,
  fetchPrizeWinners: requestPrizeWinnersAction,
  onPageSelected: page => updatePageNumberForResourceAction(ResourceApi.Types.PrizeEntry, page, {multipleWinners: true}),
  onNextClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.PrizeEntry, currentPage+1, {multipleWinners: true}),
  onPreviousClicked: currentPage => updatePageNumberForResourceAction(ResourceApi.Types.PrizeEntry, currentPage-1, {multipleWinners: true}),
};

const MultipleWinnersTable = compose(
  setDisplayName('MultipleWinnersTable'),
  withProps(props => ({
    showView: ItemExplorerViewOptions.List,
    itemsOnly: true,
    filterBarProps: {
      hidden: true
    },
    pagingBarProps: {
      count: pageCount(props.totalWinners, props.pageSize),
      total: props.totalWinners,
      currentPage: props.currentPage,
      maxPages: 10,
      onPageSelected: props.onPageSelected,
      onNextClicked: props.onNextClicked,
      onPreviousClicked: props.onPreviousClicked
    },
    tableProps: {
      items: (props.searchResults.length > 0 ? props.searchResults : props.winners).map(winner => {
        if (!winner.prize) {
          console.warn(`PrizeEntry with id '${winner.id}' has no 'prize' property.`);
        }

        return winner;
      }),
      onRowClicked: EmptyFunc,
      animatedSubRows: true,
      showSubRows: winner => winner.id === props.currentExpandedRow,
      getSubRows: winner => winner.prizeHistory,
      showSubRow: () => true,
      getSortDirectionForField: props.getSortDirectionForField,
      onSortClick: col => {
        if (col.fieldName) {
          props.selectSort(col.fieldName);
        }
      },
      colDetails: values(columns).map(col => col(props))
    }
  }))
)(ItemExplorer);

export default compose(
  setDisplayName('MultipleWinnersPage'),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentWillMount() {
      this.props.fetchPrizeWinners(this.props.prizeId);
    }
  })
)(props => (
  <DocumentTitle title='Multiple Winners'>
    <div className='multiple-winners-page'>
      {props.fetchingWinners ? <SecretSonicSpinner messageKey='loading.prizeWinners' /> : (
        <React.Fragment>
          <MultipleWinnersHeader {...props} />
          <MultipleWinnersTable {...props} />
        </React.Fragment>
      )}
    </div>
  </DocumentTitle>
));



// WEBPACK FOOTER //
// ./public/pages/MultipleWinners/MultipleWinnersPage.jsx